import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiServiceProvider } from "../api-service/api-service";
import { UserServiceProvider } from "../user-service/user-service";
import * as cbZooSettings from "../../cbSettings/cbZooFixProducts";

/*
  Generated class for the PosServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PosServiceProvider {

  
  private GEN_POS_API: string = "genpos";
  private _POS_ITEM_LIST: any;
  constructor(
    public http: HttpClient,
    public apiService: ApiServiceProvider,
    public userService: UserServiceProvider,
  ) {
    //console.log('Hello PosServiceProvider Provider');
  }

  getFixProductList(): any {
    //let temp = JSON.parse(cbZooSettings.CB_ZOO_PRODUCTS.toString());
    let productList = []
    Object.assign(productList, cbZooSettings.CB_ZOO_PRODUCTS);

    console.log(productList,"FULL PROD LIST")
    return productList;
  }

  async wcUpdateOrderByOrderID(pOrderObject) {
    var params: any;
    var res: any = {};
    res = await this.apiService.post(
      this.GEN_POS_API + "/wcUpdateOrderByOrderID",
      pOrderObject
    );
    return await res.returnData;
  }
  
  async doUpdateInGateStatus(pOrderID, pStatus: string) {
    
    var params: any ={
      userID : this.userService.getUserId(),
      posOrderID :pOrderID,
      checkStatus: pStatus
    };

    var res: any = {};

    res = await this.apiService.post(
      this.GEN_POS_API + "/doUpdateInGateStatus",
      params
    );
  
  }

  async doUpdateOrderStatus(pOrderID, pStatus: string) {
    
    var params: any ={

      orderID :pOrderID,
      status: pStatus
    };
    var res: any = {};

    res = await this.apiService.post(
      this.GEN_POS_API + "/doUpdateOrderStatus",
      params
    );
  
  }

  async getWooOrdersOnHold()
  {
    var params: any;
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/getWooOrdersOnHold",
      params
    );
    return await res;
  }

  async wcGetOrderListByClientID() {
    var params: any;
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/wcGetOrderListByClientID",
      params
    );
    return await res.returnData;
  }

  async DoGetPOS_TableInProgressStatusByStaffID() {
    var params = {
      staffID: this.userService.getUserId()
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/getPOS_TableInProgressStatusByStaffID",
      params
    );
    return await res.returnData;
  }

  async DoGetProductPriceList(pCompanyID) {
    var params = {
      companyID: pCompanyID
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/do_HandleGetProductPriceList",
      1
    );
    return await res.returnData;
  }

  async getGateDataTransactionByDate(pFromDate: any) {
    var params = {
      fromDate: pFromDate
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/do_GetGateTransactionByDate",
      params
    );
    return await res.returnData;

    let data = "";
    var request = new Request(
      "http://thaocamvienddns.ddns.net:8081/vesudung/GetListWithDate?dateAccess=10-24-2019"
    );
    //alert("I am fetching");
    fetch(request, { mode: "no-cors" })
      .then(
        function(response) {
          alert(response);
          //console.log(response);
          return response.json();
        },
        function(error) {
          //alert(error);
        }
      )
      .then(function(myJson) {
        data = myJson;
        //alert(data);
      });
    if (!data) {
      alert(
        "Không kết nối được với máy chủ cổng tự động. Kiểm tra máy chủ ở trạng thái bật"
      );
    }

    return;
    var params = {
      fromDate: pFromDate
    };
    //console.log("I am here");
    return this.http
      .get(
        "http://thaocamvienddns.ddns.net:8081/api/vesudungapi/?dateaccess=2019-10-18",
        {
          //headers: authHeader
        }
      )
      .map(response => {
        //console.log(response);
        return response;
      });

    var res: any = {};
    var api_uri =
      "http://thaocamvienddns.ddns.net:8081/api/vesudungapi/?dateaccess=2019-10-18";

    return new Promise(resolve => {
      //console.log("Last request URL to server" + api_uri);
      this.http.get(api_uri).subscribe(
        data => {
          resolve(data);
        },
        err => {
          //console.log(err);
          alert(
            "Có lỗi mất kết nối đến máy chủ. Kiểm tra đường truyền" +
              JSON.stringify(err.message)
          );
          resolve({ info: "NOT_OK", returnData: null });
        }
      );
    });
  }

  async GetPOSDataAllCategoriesSummary(pFromDate, pToDate) {
    var params = {
      fromDate: pFromDate,
      toDate: pToDate
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/GetPOSDataAllCategoriesSummary",
      params
    );
    return await res.returnData;
  }

  async GetPOSFOODDataSummary(pFromDate, pToDate) {
    let pUserID = this.userService.getUserId();

    if (pUserID == 1 || pUserID == 2 || pUserID == 5 || pUserID == 60)
    pUserID = -1; //for admin get all transaction

    var params = {
      fromDate: pFromDate,
      toDate: pToDate,
      userID : pUserID

    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/GetPOSDataTransactionForFoodAndDrink",
      params
    );
    console.log(res.returnData)
    return await res.returnData;
  }

  async GetPOSDataSummary(pFromDate, pToDate) {
    var params = {
      fromDate: pFromDate,
      toDate: pToDate
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/GetPOSDataSummary",
      params
    );
    return await res.returnData;
  }

  async GetPOSDataTransaction(pFromDate, pToDate,pUserID = -1) {
    
    if (pUserID == 1 || pUserID == 2 || pUserID == 5 || pUserID == 60)
      pUserID = -1; //for admin get all transaction
    
    var params = {
      fromDate: pFromDate,
      toDate: pToDate,
      userID :pUserID

    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/GetPOSDataTransaction",
      params
    );
    //console.log("GetPOSDataTransaction" );
    //console.log(res.returnData);
    return await res.returnData;
  }

  async DoGetPOSInfoByBarcode(pBarcode) {
    var params = {
      barCodeData: pBarcode
    };

    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/GetPOSInfoByBarcode",
      params
    );
    //console.log("barcode data detected" );
    //console.log(res.returnData);
    return await res.returnData;
  }

  async GetNewTempPOS_ORDER_ID() {
    var params: any;
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/GetNewTempPOS_ORDER_ID",
      params
    );

    return await res.returnData.POS_TEMP_ORDER_ID;
  }

  async DoPlaceNewOrderTicket(pPOSData) {
    console.log("placeing new orrder")
    if (!pPOSData) 
        return;
    if (!pPOSData.newOrderItems) 
        return;

    if (pPOSData.newOrderItems.length <= 0) 
        return;
        
    var res: any = {};
    var params: any;

    if (this.userService.getUserId() <= 0) {
      alert("UserID = 0, xin vui lòng đăng nhập lại");
      return "ĐĂNG NHẬP LẠI";
    }

    params = {
      posNewItems: pPOSData.newOrderItems,
      userID: this.userService.getUserId(),
      tableID: pPOSData.currentTable,
      posNumber: pPOSData.currentPOSStation.POS_ID,
      posOrderID: pPOSData.posOrderID,
      orderNote: pPOSData.orderNote
    };
    res = await this.apiService.post(
      this.GEN_POS_API + "/DoPlaceNewOrderTicket",
      params
    );
    //console.log(res);
    return res;
  }

  async DoPlaceNewOrder(pPOSData) {
    if (!pPOSData) return;
    //console.log(pPOSData);
    if (!pPOSData.newOrderItems) {
      alert(" Khong the submit empty order");
      return;
    }
    if (pPOSData.newOrderItems.length <= 0) {
      alert(" i am null 1");
      return;
    }
    var res: any = {};
    var params: any;

    params = {
      posNewItems: pPOSData.newOrderItems,
      userID: this.userService.getUserId(),
      tableID: pPOSData.currentTable,
      posNumber: pPOSData.currentPOSStation.POS_ID,
      posOrderID: pPOSData.posOrderID,
      orderNote: pPOSData.orderNote
    };

    res = await this.apiService.post(
      this.GEN_POS_API + "/DoPlaceNewOrder",
      params
    );
    //console.log("Return data");
    //console.log(res);
    return res.returnData;
  }

  async getPOS_TableList(pCurrentPOSStation) {
    var params: any;
    params = {
      currentPOSStation: pCurrentPOSStation.POS_ID
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/getPOS_TableList",
      params
    );
    //console.log("Return data");
    //console.log(res);
    return res.returnData;
  }

  async getPOS_WorkStationList() {
    var params: any;
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/getPOS_WorkStationList",
      params
    );
    return res.returnData;
  }

  async do_HandleGetPOS_MenuItemListByDate(pcurrentPOSStation) {
    var params: any;
    params = {
      currentPOSStation: pcurrentPOSStation.POS_ID
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/do_HandleGetPOS_MenuItemListByDate",
      params
    );

    this._POS_ITEM_LIST = res.returnData;
    return this._POS_ITEM_LIST;
  }

  async getPOS_ItemList(pcurrentPOSStation) {
    
    // if (this._POS_ITEM_LIST)
    //   return this._POS_ITEM_LIST;

    //console.log("I NEED TO FETCH DATA");
    //console.log( pcurrentPOSStation.WAREHOUSE_RELATED_ID)
    var params: any;
    params = {
      currentPOSStation: pcurrentPOSStation.WAREHOUSE_RELATED_ID
    };
    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/getPOS_ItemList",
      params
    );
    //console.log("return form Server");
    //console.log(res);
    this._POS_ITEM_LIST = res.returnData;
    return this._POS_ITEM_LIST;
  }

  async getPOS_TableTransaction(pFromDate, pToDate,pUserID = -1) {

    if (pUserID == 1 || pUserID == 2 || pUserID == 5 || pUserID == 60)
      pUserID = -1; //for admin get all transaction

    var params = {
      fromDate: pFromDate,
      toDate: pToDate,
      userID :pUserID
    };

    var res: any = {};
    res = await this.apiService.get(
      this.GEN_POS_API + "/getPOS_TableTransaction",
      params
    );
    return await res.returnData;
  }
}



// WEBPACK FOOTER //
// ./src/providers/pos-service/pos-service.ts